<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import { getGiftSubscriptionPath } from "@core/schema/paths/getGiftSubscriptionPath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./FathersClubFaqSection.translations.json" with { type: "json" };
	import SubscriptionFaqSection from "./SubscriptionFaqSection.svelte";

	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
	const { priceFrom }: { priceFrom: string } = $props();

	const faqs = $derived([
		{ question: translate("pricesQuestion"), answer: translate("pricesAnswer", { price: priceFrom }) },
		{ question: translate("changeQuestion"), answer: translate("changeAnswer") },
		{ question: translate("cancelQuestion"), answer: translate("cancelAnswer") },
		{ question: translate("deliveryQuestion"), answer: translate("deliveryAnswer") },
		{ question: translate("paymentQuestion"), answer: translate("paymentAnswer") },
		{ question: translate("monthlyQuestion"), answer: translate("monthlyAnswer") },
		{ question: translate("fathersChoiceQuestion"), answer: translate("fathersChoiceAnswer") },
		{ question: translate("giftQuestion"), answer: translate("giftAnswer", { url: getGiftSubscriptionPath(tenant) }) },
		{ question: translate("membershipQuestion"), answer: translate("membershipAnswer") },
		{ question: translate("membershipOnlyQuestion"), answer: translate("membershipOnlyAnswer") },
	]);
</script>

<SubscriptionFaqSection title={translate("faqTitle")} {faqs} group="fathers-club-faq" twoColumns />
